module.exports = {
    'CollapseSpace': require('./collapse-space'),
    'Init': require('./init')
};